<template>
  <v-container fluid grid-list-md fill-height>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <router-link v-if="customerID" :to="{ name: 'BuyersInfo', params: { buyerId:customerID }}">
          <v-btn icon dark @click="dialog = false">
            <v-icon>keyboard_backspace</v-icon>
          </v-btn>
          </router-link>
          <v-toolbar-title class="text-xs-center">Invoice History</v-toolbar-title>
          <v-spacer></v-spacer>
          <h3 class="strong white--text font-weight-light headline">
            {{this.currentUser.name}}
          </h3>
          <v-spacer></v-spacer>
          <router-link  v-if="customerID" :to="{ name: 'BuyersInfo', params: { buyerId: customerID }}">
            <v-btn icon dark @click="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </router-link>
        </v-toolbar>
        <v-card-text>
          <v-layout row wrap>
      <v-flex xs3 sm3 md3>
        <v-switch
          v-model="isStepper"
          :label="`${isStepper ? 'Stepper View' : 'Data Table View'}`"
        ></v-switch>
      </v-flex>
       <v-flex xs3 sm3 md3>
         <v-menu
            :close-on-content-click="false"
            v-model="datepicker"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="invoiceDate"
              label="Latest Invoice Date"
              prepend-icon="event"
              readonly
              @change="editMainInvoiceDate()"
            ></v-text-field>
            <v-date-picker v-model="invoiceDate"  @change="editMainInvoiceDate()" @input="datepicker = false"></v-date-picker>
          </v-menu>
      </v-flex>
      <v-flex xs2 sm2 md2 v-if="!saveInvoiceHidden">
         <v-btn color="primary" text @click="saveInvoiceDate()">Save </v-btn>
      </v-flex>
          </v-layout>
          <v-stepper v-if="isStepper" v-model="invoiceStep" vertical>
            <template v-for="(item, index) in invoiceHistoryList">
              <v-stepper-step :step="index +1" :key="item['.key']">
                <v-link @click="invoiceStep = index + 1">
                  {{item['invoiceId']}}</v-link>
                <small><b>{{new Date(item['date']).toLocaleDateString('en-GB')}}</b></small>
              </v-stepper-step>

              <v-stepper-content :step="index +1" :key="index">
                <v-card class="mb-12 invoice-stepper" >
                  <v-layout row wrap style="padding: 30px;">
                    <v-flex xs12 sm4 md4>
                      Date:
                      <b>{{new Date(item.date).toLocaleDateString('en-GB')}}</b>
                      <br />Name:
                      <!-- <b>{{ item.buyerId ? buyerById[item.buyerId].name : ''}}</b> -->
                      <b>{{ getCustomerName(item.buyerId) || ''}}</b>
                      <br />Firm:
                      <b>{{getFirmName(item.firm)}}</b>
                      <br />Duration:
                      <b>{{ item['duration']}}</b>
                      <br />Payment Type:
                      <b>{{ item['paymentType']}}</b>
                      <br />
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      Invoice Number :
                      <b>{{ item['invoiceId']}}</b>
                      <br />Total Paid Amount :
                      <b> {{ item['paidAmount']}}</b>
                       <br />Paid Amount :
                      <b v-if="item['transactionType']!='Debit'"> {{ (parseFloat(item['amountFromBank']) + parseFloat(item['amountFromCash'])) || 0 | amount}}</b>
                      <b v-else> 0</b>
                      <br />Remaining Amount :
                      <b> {{ item['remainingAmount'] || 0 | amount}}</b>
                      <br />Status :
                      <b>{{ item['status']}}</b>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                      Total Amount :
                      <b> {{ item['totalAmount'] || 0 | amount }}</b>
                      <br />Basic Amount :
                      <b> {{ (item['totalAmount'] - getGSTtotal(item)) || 0 | amount }}</b>
                      <br />Discount :
                      <b> {{ item['discountAmount'] || 0 | amount }}</b>
                      <br />GST :
                      <b> {{ getGSTtotal(item) || 0 | amount }}</b>
                      <br />GST type :
                      <b>{{ item['gstType']}}</b>
                      <br />
                      <!-- <br />Transaction Type :
                      <b>{{ item['transactionType']}}</b>
                      <br /> -->
                    </v-flex>
                     <v-flex xs12 sm12 md12>
                    <h2 style="text-decoration: underline;text-align: center;">Product List</h2>
                    <template>
                          <v-data-table
                          :headers="invoiceProductListHeader"
                          :items="item.items"
                          class="elevation-1 dashboardHead">
                          <template slot="items" slot-scope="props">
                            <td>
                              <b>{{ props.item['productName']}}</b>
                            </td>
                            <!-- <td>
                              <b>{{ props.item['.key']}}</b>
                            </td> -->
                            <td>
                              <b>{{ props.item['HSN_code']}}</b>
                            </td>
                            <td>
                              <b>{{ props.item.taxableGST_rate}}</b>
                            </td>
                            <td>
                              <b>{{ props.item['productUnit']}}</b>
                            </td>
                            <td>
                              <b>{{ props.item['quantity']}}</b>
                            </td>
                            <td>
                              <b>{{ props.item['rate']}}</b>
                            </td>
                          </template>
                          <template slot="no-data">No Items</template>
                      </v-data-table>

                    </template>
                     </v-flex>
                  </v-layout>
                </v-card>
              </v-stepper-content>
            </template>
          </v-stepper>

         <v-data-table
            v-if="!isStepper" 
            :headers="invoiceHeader"
            :items="invoiceHistoryList"
            class="elevation-1 dashboardHead">
            <template slot="items" slot-scope="props">
            <!-- <td>
              <b>{{ props.item['.key']}}</b>
            </td> -->
            <td>
              <b>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</b>  
            </td>
            <td>
               <v-btn icon class="mx-0">
                    <v-icon color="teal" @click="editInvoice(props.item)">edit</v-icon>
                  </v-btn>
            </td>
            <td>
              <b>{{ props.item.invoiceId}}</b>
              <template v-if="props.item.isLatest != undefined">
                     <v-switch
                      v-model="props.item['isLatest']"

                      :label="`${
                        props.item['isLatest'] ? 'isLatest : true' : 'isLatest : false'
                      }`"
                    ></v-switch>
                     <v-btn
                      class="mx-0"
                      @click="editHistory(props.item)"
                    >
                      save
                    </v-btn>
                    </template>
            </td>

            <!-- <td> -->
              <!-- <b>{{ props.item.buyerId ? buyerById[props.item.buyerId].name : ''}}</b> -->
              <!-- <b>{{ getCustomerName(item.buyerId) || ''}}</b> -->
              <!-- <b>{{ getCustomerName(props.item.buyerId) || ''}}</b> -->
            <!-- </td> -->
            <td>
              <b>{{getFirmName(props.item.firm)}}</b>
            </td>
            <td>
              <b class="font-weight-bold green--text">{{ props.item.paidAmount || 0 | amount }}</b>
            </td>
            <td>
              <b v-if="props.item['transactionType']!='Debit'"> {{ parseFloat((props.item['amountFromBank']) + parseFloat(props.item['amountFromCash'])) || 0 | amount}}</b>
              <b v-else> 0</b>
            </td>
            <td>
              <b class="font-weight-bold red--text">{{ props.item.remainingAmount || 0 | amount}}</b>
            </td>
            <td>
              <b class="font-weight-bold primary--text">{{ props.item.totalAmount || 0 | amount}}</b>
            </td>
            <td>
              <b class="font-weight-bold primary--text">{{ (props.item.totalAmount - getGSTtotal(props.item)) || 0 | amount }}</b>
            </td>
            <td>
              <b class="font-weight-bold primary--text">{{ getGSTtotal(props.item) || 0 | amount }}</b>
            </td>
            <td>
              <b>{{ props.item.discountAmount || 0 | amount}}</b>
            </td>
             <td>
              <b>{{ props.item.duration}}</b>
            </td>
            <td>
              <b>{{ props.item.paymentType}}</b>
            </td>
            <!-- <td>
              <b>{{ props.item.transactionType}}</b>
            </td> -->
            <td>
              <b>{{ props.item.status}}</b>
            </td>
            <td>
              <b>{{ props.item.gstType}}</b>
            </td>
            <td>
              <v-btn  v-if="props.item.closedDate" icon class="mx-0">
                <v-icon color="teal" @click="editInvoiceClosedDate(props.item)">edit</v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn icon class="mx-0" @click="deleteHistory(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
         </v-data-table>
        </v-card-text>
      </v-flex>
      <v-dialog v-model="invoiceEditDialog" width="800" v-if="currentInvoiceHistory && currentInvoiceHistory['.key']">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>Change Date: - {{currentInvoiceHistory['invoiceId']}}</v-card-title>
          <v-card-text>
             <v-menu
            :close-on-content-click="false"
            v-model="datepicker2"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="currentInvoiceHistory.date"
              label="Invoice Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="currentInvoiceHistory.date"  @input="datepicker2 = false"></v-date-picker>
          </v-menu>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="invoiceEditDialog = false">Back</v-btn>
            <v-btn color="primary" text @click="saveInvoiceHistory()">Save </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Start of Closed Date-->
      <v-dialog v-model="invoiceClosedDateEditDialog" width="800" v-if="currentInvoiceHistory && currentInvoiceHistory['.key']">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>Change Closed Date: - {{currentInvoiceHistory['invoiceId']}}</v-card-title>
          <v-card-text>
             <v-menu
            :close-on-content-click="false"
            v-model="datepicker3"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="currentInvoiceHistory.closedDate"
              label="Closed Date"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="currentInvoiceHistory.closedDate"  @input="datepicker3 = false"></v-date-picker>
          </v-menu>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="invoiceClosedDateEditDialog = false">Back</v-btn>
            <v-btn color="primary" text @click="saveClosedDateInvoiceHistory()">Save </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- End of Closed Date -->

    </v-layout>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
export default {
  data() {
    return {
      invoiceStep: 1,
      invoiceEditDialog : false,
      invoiceClosedDateEditDialog : false,
      currentInvoiceHistory : null,
      isStepper : false,
      invoiceDetails : null,
      invoiceDate : null,
      saveInvoiceHidden : true,
      customerID : '',
      currentUser: {},
      datepicker:null,
      datepicker2 : null,
      datepicker3 : null,
      invoiceProductListHeader: [
                { text: "Name", value: "Name" },
                { text: "HSN code", value: "HSN" },
                { text: "Taxable rate", value: "Taxable" },
                { text: "Unit", value: "Unit" },
                { text: "Quantity", value: "quantity" },
                { text: "Rate", value: "rate" }
            ],
            invoiceHeader : [
                // { text: "Key", value: "Name" },
                { text: "Date", value: "Name", class:"font-weight-bold primary--text" },
                { text: "Edit", value: "Name", class:"font-weight-bold primary--text" },
                { text: "Invoice Id", value: "Name", class:"font-weight-bold primary--text" },
                // { text: "Name", value: "HSN" },
                { text: "Firm", value: "Taxable", class:"font-weight-bold primary--text" },
                { text: "Total Paid Amount", value: "quantity", class:"font-weight-bold primary--text" },
                { text: "Paid Amount", value: "quantity", class:"font-weight-bold primary--text" },
                { text: "Remaining Amount", value: "quantity", class:"font-weight-bold primary--text" },
                { text: "Total Amount", value: "Unit", class:"font-weight-bold primary--text" },
                { text: "Basic Amount", value: "Unit", class:"font-weight-bold primary--text" },
                { text: "GST Amount", value: "Unit", class:"font-weight-bold primary--text" },
                { text: "Discount", value: "Unit", class:"font-weight-bold primary--text" },
                { text: "Duration", value: "Unit", class:"font-weight-bold primary--text" },
                { text: "Payment type", value: "quantity", class:"font-weight-bold primary--text" },
                // { text: "Transaction Type", value: "Unit", class:"font-weight-bold primary--text" },
                { text: "Status", value: "Unit", class:"font-weight-bold primary--text" },
                { text: "GST type", value: "Unit", class:"font-weight-bold primary--text" },
                { text: "Closed Date", value: "Unit", class:"font-weight-bold grey--text" },
                { text: "Delete", value: "delete", class:"font-weight-bold grey--text" },
            ]
    };
  },
  mounted() {
    this.getCurrentUser();
  },
  created() {
    this.$bindAsArray("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("invoiceById", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "brandFinYear"]),
    ...mapBuyerGetters(["selectedBuyer"]),
    invoiceHistoryList() {
      if(!this.invoiceDetails) {
        this.getInvoiceObj()
      }
      let invoiceHistory =  this.invoiceHistory.filter(
        item => item["parentInvoiceKey"] === this.$route.params.invoiceId
      );
      this.customerID = invoiceHistory.length && invoiceHistory[0].buyerId;
      return invoiceHistory;
    }
  },
  methods: {
    editHistory(history){
      const copy = {...history}
      if(confirm("Are you sure?")) {
        let key = copy['.key'];
        delete copy['.key']
        this.$root.$firebaseRefs.invoiceHistory.child(key).set(copy)
      }
      
    },
    getInvoiceObj(){
      this.invoiceDetails = this.invoiceById[this.$route.params.invoiceId];
      if(this.invoiceDetails) {
        this.invoiceDate = new Date(this.invoiceDetails.date).toISOString().substr(0, 10)
      }
    },
    editInvoice(inv){
      this.invoiceEditDialog = true;
      this.currentInvoiceHistory = inv;
      this.currentInvoiceHistory.date = new Date(inv.date).toISOString().substr(0, 10)
    },
    editInvoiceClosedDate(inv){
      this.invoiceClosedDateEditDialog = true;
      this.currentInvoiceHistory = inv;
      this.currentInvoiceHistory.closedDate = new Date(inv.closedDate).toISOString().substr(0, 10)
    },
    saveInvoiceHistory(){
      this.$root.$firebaseRefs.invoiceHistory.child(this.currentInvoiceHistory['.key']).update({
          date: new Date(this.currentInvoiceHistory.date).getTime()
      });
       this.invoiceEditDialog = false;
    },
    saveClosedDateInvoiceHistory(){
      this.$root.$firebaseRefs.invoiceHistory.child(this.currentInvoiceHistory['.key']).update({
          closedDate: new Date(this.currentInvoiceHistory.closedDate).getTime()
      });
       this.invoiceClosedDateEditDialog = false;
    },
    saveInvoiceDate(){
      this.$root.$firebaseRefs.invoice.child(this.$route.params.invoiceId).update({
          date: new Date(this.invoiceDate).getTime()
      });
      this.saveInvoiceHidden = true;
    },
    editMainInvoiceDate(){
      this.saveInvoiceHidden = false;
    },
    deleteHistory(inv) {
      this.currentInvoiceHistory = inv;
      if (window.confirm("Do you want to Delete Invoice History ?")) {
        // this.$root.$firebaseRefs.invoiceHistory.child(invoiceHistory[".key"]).remove();
        this.$root.$firebaseRefs.invoiceHistory.child(this.currentInvoiceHistory['.key']).remove();
        //this.addRemainingBalance();
      }
    },
    getFirmName(firmId) {
      if (this.firms && this.firms[firmId]) {
        return this.firms[firmId]["name"];
      }
      return "--";
    },
    getCurrentUser() {
      let buyer = this.buyerById[this.selectedBuyer];
      let seller = this.sellerById[this.selectedBuyer];
      this.isUserBuyer = buyer ? true : false;
      this.currentUser =
        buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
    },
    getCustomerName(id) {
      let buyer = this.buyerById[id];
      let seller = this.sellerById[id];
      return buyer ? buyer.name : seller.name;
    },
    getGSTtotal(item) {
      let GSTTotal = 0;
      item && item.items && item.items.map(item => {
          GSTTotal += Number.parseFloat(item.GSTValue);
      });
      return GSTTotal;
    },
  }
};
</script>
<style scoped>
.invoice-stepper {
  border: 1px solid #01579b;
  border-radius: 4px;
  background: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/components/Buyers/InvoiceHistory/index.vue